/**
 * The one place the agent says it is busy (v1.98): one line for the run, gone
 * with it. While a tool runs, the line says what it does (#85): the server's
 * words, such as "Searching the web for “x”".
 */
import { useChat, type Activity } from "./store";
import styles from "./Thinking.module.css";

const WORDS: Record<Activity, string> = {
  sending: "sending",
  thinking: "thinking",
  joined: "picking that up too",
  working: "still working",
};

export function Thinking({ compact = false }: { compact?: boolean }) {
  const activity = WORDS[useChat((s) => s.activity)];
  const step = useChat((s) => s.step);
  const word = step ?? activity;
  return (
    <div
      className={compact ? `${styles.thinking} ${styles.compact}` : styles.thinking}
      aria-live="polite"
      aria-label={`${word}…`}
    >
      <span className={styles.dots} aria-hidden="true">
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </span>
      {/* Keyed, so a new word sweeps from the left rather than mid-shimmer. */}
      <span key={word} className={styles.word}>
        {word}
      </span>
    </div>
  );
}
